import React from "react";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import { QuizChooseItem } from "~/modules/QuizChooseItem";

const Theme42Task2 = () => {
  const items: { name: string }[] = [
    {
      name: "Олимпийская слобода"
    },
    {
      name: "Олимпийская деревня"
    },
    {
      name: "Олимпийский парк"
    },
    { name: "Олимпийский двор" }
  ];
  return (
    <QuizWrapper
      title='Тест'
      icon='test'
      subtitle='Как называется район Москвы, выстроенный к Олимпийским играм?'
      description='Выбери правильный ответ'
      successIcon='rus-1'
    >
      <QuizChooseItem type='str' items={items} correctItem='Олимпийская деревня' sameHeight />
    </QuizWrapper>
  );
};

export default Theme42Task2;
